import { Button, Stack, TextField } from '@mui/material';

export default function PinCodeForm({
  newPincode,
  setNewPincode,
  setEditing,
  handlePincodeSubmit,
}: {
  newPincode: string;
  setNewPincode: any;
  setEditing: any;
  handlePincodeSubmit: any;
}) {
  return (
    <>
      <TextField
        label="Pincode"
        variant="outlined"
        value={newPincode}
        onChange={(e) => setNewPincode(e.target.value)}
        sx={{ width: '100%' }}
        size="small"
      />
      <Stack direction={'row'} justifyContent={'flex-end'} gap={2}>
        <Button
          variant="outlined"
          onClick={() => setEditing(false)}
          sx={{ textTransform: 'none', ml: 2 }}
        >
          Cancel
        </Button>
        <Button variant="contained" onClick={handlePincodeSubmit} sx={{ textTransform: 'none' }}>
          Next
        </Button>
      </Stack>
    </>
  );
}
